document.addEventListener('DOMContentLoaded', function () {

  var FIT_ORDER   = ['Short', 'Regular', 'Long'];
  var ALPHA_ORDER = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', '3XL'];

  function getLabelText(el) {
    var label = el.querySelector('label') || el.querySelector('.block-swatch') || el;
    var clone = label.cloneNode(true);
    clone.querySelectorAll('svg, input, .animated-plus').forEach(function (x) { x.remove(); });
    return clone.textContent.trim();
  }

  function getOptionGroupLabel(container) {
    var el = container.parentElement;
    for (var i = 0; i < 8; i++) {
      if (!el) break;
      var info = el.querySelector('.variant-picker__option-info');
      if (info) {
        var clone = info.cloneNode(true);
        clone.querySelectorAll('a, button, svg').forEach(function (x) { x.remove(); });
        return clone.textContent.trim().toLowerCase();
      }
      el = el.parentElement;
    }
    return '';
  }

  function reorderOptions() {
    document.querySelectorAll('.variant-picker__option-values').forEach(function (container) {

      var groupLabel = getOptionGroupLabel(container);
      var items       = Array.from(container.children).filter(function (el) { return el.tagName === 'LABEL'; });

      if (items.length < 2) return;

      var sorted = null;

      if (/fit/i.test(groupLabel)) {
        sorted = items.slice().sort(function (a, b) {
          var ai = FIT_ORDER.indexOf(getLabelText(a));
          var bi = FIT_ORDER.indexOf(getLabelText(b));
          return (ai === -1 ? 99 : ai) - (bi === -1 ? 99 : bi);
        });
      }

      else if (/size/i.test(groupLabel)) {
        var texts      = items.map(getLabelText);
        var allNumeric = texts.every(function (t) { return /^\d+(\.\d+)?$/.test(t); });
        var allAlpha   = texts.every(function (t) { return ALPHA_ORDER.indexOf(t.toUpperCase()) !== -1; });

        if (allNumeric) {
          sorted = items.slice().sort(function (a, b) {
            return parseFloat(getLabelText(a)) - parseFloat(getLabelText(b));
          });
        } else if (allAlpha) {
          sorted = items.slice().sort(function (a, b) {
            var ai = ALPHA_ORDER.indexOf(getLabelText(a).toUpperCase());
            var bi = ALPHA_ORDER.indexOf(getLabelText(b).toUpperCase());
            return (ai === -1 ? 99 : ai) - (bi === -1 ? 99 : bi);
          });
        }
      }

      if (sorted) {
        var changed = sorted.some(function (item, i) { return item !== items[i]; });
        if (changed) {
          sorted.forEach(function (label) { var input = container.querySelector('input[id="' + label.htmlFor + '"]'); if (input) container.appendChild(input); container.appendChild(label); });
        }
      }
    });
  }

  reorderOptions();
document.addEventListener('variant:change', function() {
  setTimeout(reorderOptions, 50);
});

  var observer = new MutationObserver(function () { reorderOptions(); });
  document.querySelectorAll('.variant-picker').forEach(function (el) {
    observer.observe(el, { childList: true, subtree: true });
  });

});

/* Shop the Look drawer — inline quick add (Shop → variant selects + ATC) */
(function () {
  if (window.customElements.get('shop-the-look-quick-add')) return;

  class ShopTheLookQuickAdd extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-shop-trigger]');
      this.panel = this.querySelector('.shop-the-look-quick-add__panel');
      this.form = this.querySelector('form');
      this.idInput = this.form?.querySelector('input[name="id"]');
      this.submitButton = this.form?.querySelector('[type="submit"]');
      this.selects = Array.from(this.querySelectorAll('[data-option-position]'));
      this.variants = this.parseVariants();
      this.errorEl = null;
      this.errorTimeout = null;

      this.trigger?.addEventListener('click', this.onShopClick.bind(this));
      this.selects.forEach((select) => {
        select.addEventListener('change', this.onOptionChange.bind(this));
      });
      this.form?.addEventListener('cart:error', this.onCartError.bind(this));
      this.form?.addEventListener('variant:add', this.clearError.bind(this));
    }

    parseVariants() {
      const script = this.querySelector('[data-product-variants]');
      if (!script) return [];
      try {
        return JSON.parse(script.textContent);
      } catch (e) {
        return [];
      }
    }

    onShopClick() {
      document.querySelectorAll('shop-the-look-quick-add.is-expanded').forEach((el) => {
        if (el !== this) el.collapse();
      });
      this.expand();
    }

    expand() {
      this.classList.add('is-expanded');
      if (this.trigger) this.trigger.hidden = true;
      if (this.panel) this.panel.hidden = false;
      this.clearError();
      this.updateVariant();
      this.selects[0]?.focus();
    }

    collapse() {
      this.classList.remove('is-expanded');
      if (this.trigger) this.trigger.hidden = false;
      if (this.panel) this.panel.hidden = true;
      this.clearError();
    }

    onOptionChange() {
      this.clearError();
      this.updateVariant();
    }

    onCartError(event) {
      const message = event.detail?.error || event.detail?.message;
      if (!message) return;

      this.clearError();

      const banner = document.createElement('div');
      banner.className = 'banner banner--error shop-the-look-quick-add__error';
      banner.setAttribute('role', 'alert');
      banner.textContent = message;
      this.errorEl = banner;
      this.form?.prepend(banner);

      this.errorTimeout = setTimeout(() => this.clearError(), 5000);
    }

    clearError() {
      if (this.errorTimeout) {
        clearTimeout(this.errorTimeout);
        this.errorTimeout = null;
      }
      this.errorEl?.remove();
      this.errorEl = null;
    }

    getSelectedOptions() {
      return this.selects
        .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
        .map((select) => select.value);
    }

    findVariant(selectedOptions) {
      return this.variants.find((variant) =>
        selectedOptions.every((value, index) => variant['option' + (index + 1)] === value)
      );
    }

    updateVariant() {
      if (!this.idInput || !this.submitButton) return;

      if (this.selects.length === 0) {
        this.submitButton.disabled = this.idInput.disabled;
        return;
      }

      const variant = this.findVariant(this.getSelectedOptions());

      if (!variant) {
        this.idInput.value = '';
        this.idInput.disabled = true;
        this.submitButton.disabled = true;
        return;
      }

      this.idInput.value = variant.id;
      this.idInput.disabled = !variant.available;
      this.submitButton.disabled = !variant.available;
    }
  }

  window.customElements.define('shop-the-look-quick-add', ShopTheLookQuickAdd);
})();